import * as React from 'react';
import { Box, Button, CircularProgress, SxProps, Theme } from '@mui/material';
import { Palette } from '../@shared/palette';

type ButtonComponentType = {
    disabled?: boolean,
    onClick?: () => void,
    isProcessing?: boolean,
    text: string,
    sx: SxProps<Theme>
}

export const ButtonComponent = React.forwardRef<HTMLButtonElement, ButtonComponentType>((props, ref) => {
    return <Button ref={ref} sx={{ ...props.sx, position: "relative" }} disabled={props.isProcessing || props.disabled} onClick={props.onClick}>{props.text}
        {props.isProcessing && <Box sx={{ width: "100%", height: "100%", position: "absolute", top: 0, left: 0, background: Palette.btnPrimaryHover }}>
            <CircularProgress
                size={24}
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: '-12px',
                    marginLeft: '-12px',
                    color: Palette.btnPrimary
                }} />
        </Box>}</Button>
})